import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { toNumberString } from '@delmonicos/shared-sdk/libs/core/src/utils/formatters/number.formatters';
import { TransactionReportsEcologyStatisticsModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction-report/transaction-reports-ecology-statistics.model';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import * as css from '@app/feature/statistics/statistics.module.scss';

interface EnvironmentalDataCardProps {
  data?: TransactionReportsEcologyStatisticsModel;
}

export const EnvironmentalDataCard = ({
  data,
}: EnvironmentalDataCardProps): React.JSX.Element => {
  const { t, i18n } = useTranslation();

  return (
    <Card flex={1}>
      <Stack gap={GapEnum.L} direction="column">
        <AccentTitle
          as={HeadingEnum.H2}
          icon="globe-04"
          text={t('$.statistics.environmental-data.title')}
        />
        <Stack
          alignItems="center"
          className={classNames([css.highlighted, css[`highlighted-primary`]])}
          direction="row"
          gap={GapEnum.M}
          justifyContent="space-between">
          <Stack
            alignItems="center"
            gap={GapEnum.XS}
            flex={1}
            justifyContent="flex-start">
            <Text fontSize={TextFontSize.Large}>
              {t('$.statistics.environmental-data.fuel-saved')}
            </Text>
          </Stack>
          <Text bold fontSize={TextFontSize.Large}>
            {data ? `${toNumberString(data.fuel, i18n.language, 0, 0)} L` : '-'}
          </Text>
        </Stack>
        <Stack
          alignItems="center"
          className={classNames([css.highlighted, css[`highlighted-primary`]])}
          direction="row"
          gap={GapEnum.M}
          justifyContent="space-between">
          <Stack
            alignItems="center"
            gap={GapEnum.XS}
            flex={1}
            justifyContent="flex-start">
            <Text fontSize={TextFontSize.Large}>
              {t('$.statistics.environmental-data.distance-avoided')}
            </Text>
          </Stack>
          <Text bold fontSize={TextFontSize.Large}>
            {data ? `${toNumberString(data.km, i18n.language, 0, 0)} km` : '-'}
          </Text>
        </Stack>
      </Stack>
    </Card>
  );
};
